export default __webpack_public_path__ + "static/media/argentan11.6d041440.jpg";